import React from 'react';
import { Helmet } from 'react-helmet';
import type { SharingMetadata } from '../../config/sharingPolicy.mjs';

export default function PublicSharingMetadata({ metadata: m }: { metadata: SharingMetadata }) {
  return <Helmet>
    <title>{m.title}</title><meta name="description" content={m.description} />
    <meta property="og:title" content={m.title} /><meta property="og:description" content={m.description} />
    <meta property="og:image" content={m.image} /><meta property="og:url" content={m.url} />
    {m.imageWidth && <meta property="og:image:width" content={String(m.imageWidth)} />}
    {m.imageHeight && <meta property="og:image:height" content={String(m.imageHeight)} />}
    <meta property="og:site_name" content={m.siteName} /><meta property="og:type" content="website" />
    <meta name="twitter:card" content="summary_large_image" /><meta name="twitter:title" content={m.title} />
    <meta name="twitter:description" content={m.description} /><meta name="twitter:image" content={m.image} />
    <link rel="canonical" href={m.url} /><link rel="icon" href={m.favicon} />
    {m.siteIcon && <link rel="icon" type="image/png" sizes="512x512" href={m.siteIcon} />}
    {m.noindex && <meta name="robots" content="noindex" />}
  </Helmet>;
}
